<template>
  <post-full :post="post"/>
</template>

<script>
import PostFull from './PostFull.vue';

export default {
  name: 'post',
  components: {
    PostFull,
  },
  props: {
    post: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="stylus">
  .post
    display flex
    flex-direction column
    &-comments
      border-top 1px solid #ccc
      width 100%
      margin-top 1em
      padding 1em 0
      &-count
        display flex
        align-items center
        cursor pointer
        margin-bottom 1em
        &__icon
          width 1.4em
          hieght 1.4em
          margin 0 1em 0 0
        &__show
          display inline-block
          margin-left 1em
          font-weight bold
          color #460303
          cursor pointer
        &__show-more
          display inline-block
          margin-left 1em
          font-weight bold
          color #460303
          cursor pointer
  .post-footer
    display flex
    justify-content flex-end
    align-items center
    .to-original
      margin-right 15px;
      font-size 12px
      color #460303
      text-decoration none
</style>
